export { default, default as DeactivateUserModal } from "./DeactivateUserModal";
